module.exports = __webpack_public_path__ + "static/media/Soybean15R8.ae570a3a.PNG";